module.exports = __webpack_public_path__ + "img/mastercard.0b30c62e.svg";